import React from "react"
import ReactSlider from "react-slider"

import "./slider.sass"

const Slider = ({ step, ...props }) => {
  const renderThumbLabel = props.renderThumbLabel || ((val) => <>{val}</>)
  return (
    <div className="slider-container">
      {props.label && <div className="slider-label">{props.label}</div>}
      <ReactSlider
        className="_fp-horizontal-slider"
        thumbClassName="slider-thumb"
        trackClassName="slider-track"
        ariaLabel={["Lower thumb", "Upper thumb"]}
        ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
        renderThumb={(props, state) => (
          <div {...props}>
            <div className={"slider-thumb__label"}>
              {renderThumbLabel(state.valueNow)}
            </div>
          </div>
        )}
        pearling
        step={step || 0.1}
        minDistance={0}
        {...props}
      />
    </div>
  )
}

export default Slider
